import { Injectable } from '@angular/core';
import { generateClient } from 'aws-amplify/api';
import * as queries from '@graphql/queries';
import * as mutations from '@graphql/mutations';
import {
    CreateMercadoProductCategoryClientInput,
    MercadoProductCategoryClient,
    UpdateMercadoProductCategoryClientInput
} from '@app/core/services/api/API.service';
@Injectable({
    providedIn: 'root'
})
export class MercadoProductCategoryClientService {
    private amplifyClient = generateClient();
    constructor() {}

    async listMercadoProductCategoryClients(): Promise<
        MercadoProductCategoryClient[]
    > {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.listMercadoProductCategoryClients
                })
            ).data.listMercadoProductCategoryClients.items;
            if (data) return data as MercadoProductCategoryClient[];
        } catch (error) {
            console.error('Error finding MercadoProductCategoryClient:', error);
            return null;
        }
    }
    async mercadoProductsByClient(
        idClient: string
    ): Promise<MercadoProductCategoryClient[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.MercadoProductsByClient,
                    variables: {
                        idClient
                    }
                })
            ).data.MercadoProductsByClient.items;
            if (data) return data as MercadoProductCategoryClient[];
        } catch (error) {
            console.error('Error finding MercadoProductCategoryClient:', error);
            return null;
        }
    }
    async mercadoProductsByCategory(
        idMercadoCategory: string
    ): Promise<MercadoProductCategoryClient[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.MercadoProductsByCategory,
                    variables: {
                        idMercadoCategory
                    }
                })
            ).data.MercadoProductsByCategory.items;
            if (data) return data as MercadoProductCategoryClient[];
        } catch (error) {
            console.error('Error finding MercadoProductCategoryClient:', error);
            return null;
        }
    }
    async createMercadoProductCategoryClient(
        input: CreateMercadoProductCategoryClientInput
    ): Promise<MercadoProductCategoryClient> {
        try {
            const date = (
                await this.amplifyClient.graphql({
                    query: mutations.createMercadoProductCategoryClient,
                    variables: {
                        input
                    }
                })
            ).data.createMercadoProductCategoryClient;
            if (date) return date as MercadoProductCategoryClient;
        } catch (error) {
            console.error(
                'Error creating MercadoProductCategoryClient:',
                error
            );
            return null;
        }
    }
    async updateMercadoProductCategoryClient(
        input: UpdateMercadoProductCategoryClientInput
    ): Promise<MercadoProductCategoryClient> {
        try {
            const date = (
                await this.amplifyClient.graphql({
                    query: mutations.updateMercadoProductCategoryClient,
                    variables: {
                        input
                    }
                })
            ).data.updateMercadoProductCategoryClient;
            if (date) return date as MercadoProductCategoryClient;
        } catch (error) {
            console.error(
                'Error creating MercadoProductCategoryClient:',
                error
            );
            return null;
        }
    }
}
